export const config = {
  ROWS_PER_PAGE: 5,
  VISIBLE_PAGE_NUMBERS: 3,
}
